import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-signup-form',
  templateUrl: './signup-form.component.html',
  styleUrls: ['./signup-form.component.scss'],
})
export class SignupFormComponent implements OnInit, OnChanges {

  @Input() type: string | undefined; // Type = SIGNUP (OUT SIDE) | CREATE (INSIDE through ADMIN) | UPDATE (update USER) | MISSING (Only Update Ou);
  @Input() data: any; // For user update data
  @Output() updatedData = new EventEmitter<any>();
  @Output() signupCompleted = new EventEmitter<any>();
  @Output() signupFailed = new EventEmitter<string>();
  @Input() hideRole: boolean = false;
  @Input() formUserProfile: boolean = false;
  @Input() hidePermissionSelection: boolean = false;
  @Input() presetPermissionRequests: string[] | null = null;
  currentOU: any;
  myForm: FormGroup | any;
  signupSuccess = false;
  message: undefined | string;
  city: Array<Location | any> = [];
  roles: Array<any> = [];

  ous: Array<OrganizationUnit> = [];
  filtredOus: Array<OrganizationUnit> = [];
  selectedOus: Array<OrganizationUnit> | any = [];
  selectedOusIds: Array<String> | any = [];
  loading: boolean = true;
  gender = [{ label: 'ذكر' }, { label: 'أنثى' }];

  addOu: boolean = false;
  uid: any

  

  ngOnInit() {
    if (this.type == 'UPDATE' || this.type == 'MISSING' || this.type == 'CREATE') {
      // console.log("Data Recieved===>",this.data);

      Promise.all([this.getRoles(), this.getOUs(), this.getCity()]).then((e) => {
        //Loading All OUS
        if (this.data?.ou) {
          this.data?.ou.forEach((item: any) => {
            this.handleOU(item._id, true);
          });
        }

        this.applyLocationToForm();
        this.loading = false;
        this.initializePermissions();
      });
    } else {
      Promise.all([this.getOUs(), this.getCity()]).then((e) => {
        //Loading All OUS
        this.data?.ou.forEach((item: any) => {
          this.handleOU(item._id, true);
        });
        this.loading = false;
      });
    }
    this.constructForObject();
    this.uid = this.data?._id
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['presetPermissionRequests'] && !changes['presetPermissionRequests'].firstChange) {
      this.applyPresetPermissions();
    }
  }



  constructForObject() {
    let typedisabled = this.type == 'MISSING'
    let emailDisabled = typedisabled || this.formUserProfile
    let genderDisabled = typedisabled || this.formUserProfile
    
    if (this.type == 'UPDATE' || this.type == 'MISSING' || this.type == 'CREATE') {
      this.myForm = this.formBuilder.group({
        fName: [
          { value: this.data?.name?.first, disabled: typedisabled },
          [Validators.required, Validators.minLength(3)],

        ],
        mName: [
          { value: this.data?.name?.middle, disabled: typedisabled },
          [Validators.required]],
        lName: [
          { value: this.data?.name?.last, disabled: typedisabled },
          [Validators.required, Validators.minLength(3)],
        ],
        email: [
          { value: this.data?.email, disabled: emailDisabled },
          [Validators.required, Validators.email]],
        phone: [
          { value: this.data?.phone, disabled: typedisabled },
          [
            Validators.required,
            Validators.pattern(
              '^[+]?[0]?[0]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$'
            ),
          ],
        ],
        national_id: [
          { value: this.data?.national_id, disabled: typedisabled },
          [Validators.required, Validators.pattern('^[0-9]{10}$')],
        ],
        gender: [{ value: { label: this.data?.gender }, disabled: genderDisabled }, [Validators.required]],
        role: [{ value: this.data?.role ? (this.data.role._id || this.data.role) : '', disabled: typedisabled }, typedisabled ? [] : [Validators.required]],
        location: [
          this.resolveLocationId(this.data?.location),
          [Validators.required],
        ],
        permissionRequests : [this.data?.permissionRequests],
      });
    } else {
      this.myForm = this.formBuilder.group({
        fName: [null, [Validators.required, Validators.minLength(3)]],
        mName: [null, [Validators.required]],
        lName: [null, [Validators.required, Validators.minLength(3)]],
        email: ['', [Validators.required, Validators.email]],
        phone: [
          null,
          [
            Validators.required,
            Validators.pattern(
              '^[+]?[0]?[0]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$'
            ),
          ],
        ],
        national_id: [
          null,
          [Validators.required, Validators.pattern('^[0-9]{10}$')],
        ],
        gender: [null, [Validators.required]],
        location: [null, [Validators.required]],
        recaptcha: ['', Validators.required],
        permissionRequests : [],
      });
    }



    this.permissionsForm = this.formBuilder.group({
      ASSESSMENT: [false],
      SURVEY: [false],
      TRAINING: [false]
    });

    this.applyPresetPermissions();

    if (this.type === 'MISSING' && !this.resolveLocationId(this.data?.location)) {
      this.myForm.get('location')?.markAsTouched();
    }
  }

  private resolveLocationId(location: unknown): string {
    if (!location || (typeof location === 'object' && 'href' in (location as { href?: string }))) {
      return '';
    }
    if (typeof location === 'string') {
      return location;
    }
    const loc = location as { _id?: string; value?: string };
    return loc._id ?? loc.value ?? '';
  }

  /** Set city after options load; infer from OU when user has no location (imported flow). */
  private applyLocationToForm(): void {
    if (!this.myForm) return;
    let locationId = this.resolveLocationId(this.data?.location);
    if (!locationId) {
      locationId = this.inferLocationIdFromOrganizationalUnits();
    }
    if (!locationId) return;

    const control = this.myForm.get('location');
    control?.setValue(locationId);
    control?.updateValueAndValidity();
  }

  private inferLocationIdFromOrganizationalUnits(): string {
    const sources = [...(this.selectedOus ?? []), ...(this.data?.ou ?? [])];
    for (const ou of sources) {
      const id = this.resolveLocationId(ou?.location);
      if (id) return id;
    }
    return '';
  }

  permissionsForm : any

  
  

  constructor(
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    if (this.type == 'SIGNUP') {
      this.myForm = this.formBuilder.group({
        fName: [null, [Validators.required, Validators.minLength(3)]],
        mName: [null, [Validators.required]],
        lName: [null, [Validators.required, Validators.minLength(3)]],
        email: [{ value: '', disabled: this.formUserProfile }, [Validators.required, Validators.email]],
        phone: [
          null,
          [
            Validators.required,
            Validators.pattern(
              '^[+]?[0]?[0]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$'
            ),
          ],
        ],
        national_id: [
          null,
          [Validators.required, Validators.pattern('^[0-9]{10}$')],
        ],
        gender: [{ value: null, disabled: this.formUserProfile }, [Validators.required]],
        location: [null, [Validators.required]],
        recaptcha: ['', Validators.required],
        permissionRequests : [],
      });
    } else {
      this.myForm = this.formBuilder.group({
        fName: [null, [Validators.required, Validators.minLength(3)]],
        mName: [null, [Validators.required]],
        lName: [null, [Validators.required, Validators.minLength(3)]],
        email: [{ value: '', disabled: this.formUserProfile }, [Validators.required, Validators.email]],
        phone: [
          null,
          [
            Validators.required,
            Validators.pattern(
              '^[+]?[0]?[0]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$'
            ),
          ],
        ],
        national_id: [
          null,
          [Validators.required, Validators.pattern('^[0-9]{10}$')],
        ],
        gender: [{ value: null, disabled: this.formUserProfile }, [Validators.required]],
        location: [null, [Validators.required]],
        role: [null, []],
        permissionRequests : [],
      });
    }
  }

  async onSubmit() {
    // handle form submission
    this.myForm;
    let email, active;

    if (this.filtredOus.length > 0) {
      this.message = 'الرجاء تحديد قائمة جميع الوحدات التنظيمية';
      return;
    }

    // In `formUserProfile` mode the email/gender controls are intentionally
    // disabled, but Angular's `myForm.value` strips disabled fields. Use
    // `getRawValue()` for that mode so `createLoginObject` still receives
    // the email/gender (and any other disabled fields) and doesn't crash on
    // `data.gender.label`. All other call sites keep their original behavior.
    let data: any = this.createLoginObject(
      (this.formUserProfile || this.type === 'MISSING') ? this.myForm.getRawValue() : this.myForm.value
    );
    if (
      (this.type == 'UPDATE' || this.type == 'CREATE') &&
      (data.role == '' || data.role == null)
    ) {
      this.message = 'الدور المطلوب';
      return;
    }

    if (this.type == 'SIGNUP') delete data.role;

    let response: any;
    switch (this.type) {
      case 'UPDATE':
        data._id = this.data._id;
        email = data.email;
        active = this.data.active;
        data.role = [data.role];
        data.active = this.data.active;
        if (this.data?.email == data.email) delete data.email;
        response = await this.dataService.postData('user', data, 'PUT', false);
        break;

      case 'MISSING':
        delete data.role;
        delete data.name;
        data._id = this.data._id;
        email = data.email;
        active = this.data.active;
        data.active = this.data.active;
        data.externalUser = { imported: false, status: false };
        if (this.data?.email == data.email) delete data.email;
        response = await this.dataService.postData('user/missing', data, 'PUT', false);
        break;
      case 'SIGNUP':
        response = await this.dataService.postData('user/register', data);
        break;
      case 'CREATE':
        response = await this.dataService.postData('user/create', data);
        break;
      default:
        return;
    }
    if (response.error == true) {
      this.message = response.msg;
      this.signupFailed.emit(this.message || '');
    } else {
      this.message = this.translate(response.msg);
      this.signupSuccess = true;
      if (this.type === 'SIGNUP') {
        this.signupCompleted.emit(response.data || null);
      }
      if (this.type == 'MISSING') {
        this.router.navigate(["/home"]);
      }
    }

    if (this.type == 'UPDATE' && !response.error) {
      this.data = data;
      let obj = JSON.parse(JSON.stringify(this.data));

      //Getting location and setting in object
      let location = this.city.find((e) => e.value === data.location);
      location._id = location.value;
      delete location.value;
      obj.location = location;

      obj.email = email;
      obj.active = active;

      let role = this.roles.find((e) => e.value === data.role[0]);
      role._id = role.value;
      role.name = role.label;
      delete role.value;
      delete role.label;

      obj.role = role;

      console.log(data, obj);

      obj.ou = [];
      data.ou.forEach((id: string) => {
        obj.ou.push(this.ous.find((o: OrganizationUnit) => id === o._id));
      });
      this.updatedData.emit(obj);
    }
  }

  createLoginObject(data: any) {
    console.log('data from File', data);
    return {
      name: {
        first: data.fName,
        middle: data.mName,
        last: data.lName,
      },
      email: data.email,
      phone: data.phone,
      national_id: data.national_id,
      gender: data.gender.label,
      location: data.location,
      ou: this.selectedOusIds,
      role: data.role,
      active: {
        status: false,
        reason: 'NEW ACCOUNT',
        activationDate: null,
      },
      permissionRequests : data.permissionRequests ? data.permissionRequests : []
    };
  }

  async getRoles() {
    try {
      let res = await this.dataService.getData('role');
      if (!res.error) {
        this.roles = res.data.map((location: any) => {
          return {
            value: location._id,
            label: location.name,
          };
        });
        console.log('this.role', this.roles);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getCity() {
    try {
      let res = await this.dataService.getData('location');
      if (!res.error) {
        this.city = res.data.map((location: any) => {
          return {
            value: location._id,
            label: location.name,
            icon: 'pi pi-map-marker',
          };
        });
        this.applyLocationToForm();
      }
    } catch (error) {
      console.log(error);
    }
  }

  selectionName: string = 'الجهة'

  async handleOU(id: any, onInitFLag = false) {

    this.message = ''

    let selectedOU = this.ous.find((ou: any) => ou._id == id)



    if (selectedOU?.allowSingleUser && !onInitFLag) {
      let count = await this.checkManger(selectedOU._id)
      if (count.length >= 1) {
        if (!this.uid || this.uid !== count[0]._id) {
          this.message = this.translate('Can Not Create Any other user with this designation')
          return
        }
      }
    }

    this.selectedOusIds.push(id);
    this.selectedOus.push(selectedOU);
    
    this.filtredOus = this.ous.filter(
      (ou: any) => ou.parent?._id == id 
      && (ou.location?._id == this.myForm.get('location').value || !ou.location || ou.location?._id == '64647832ff8dc886e5d30cd6')
    );

    // Extract unique category names
    const uniqueCategoryNames = [...new Set(this.filtredOus.map((obj: any) => obj.type.name))];

    // Create a string separated by '/'
    this.selectionName = uniqueCategoryNames.join('/ ');


    console.log('this.filtredOus => ', id, this.filtredOus, this.selectedOus, this.selectionName);
    this.addOu = false;
  }

  async checkManger(id: string) {
    try {
      let res = await this.dataService.postData('user/findManager', { ou: id });
      if (!res.error) {
        return res.data
      }
    } catch (error) {
      console.log(error);
    }
  }

  deleteOU(index: any) {
    this.selectedOus.splice(index);
    this.selectedOusIds.splice(index);
    console.log(this.filtredOus)
    if (this.selectedOus.length === 0) {
      this.filtredOus = this.ous.filter((ou) => ou.parent?._id == null);
      this.selectionName = 'الجهة'
    } else {
      this.filtredOus = this.ous.filter(
        (ou: any) => ou.parent?._id == this.selectedOus[this.selectedOus.length - 1]._id && (ou.location?._id == this.myForm.get('location').value || !ou.location || ou.location?._id == '64647832ff8dc886e5d30cd6')
      );
      // Extract unique category names
      const uniqueCategoryNames = [...new Set(this.filtredOus.map((obj: any) => obj.type.name))];
      // Create a string separated by '/'
      this.selectionName = uniqueCategoryNames.join('/ ');
    }
    this.cdr.detectChanges();
  }

  ouHolder: OrganizationUnit | undefined;

  allowedTags = ['Ministries/Entities', 'Organisational Units', 'Organisational Structure', 'Branches']



  changeCityFilter() {
    // console.log("===>City get",  this.myForm.get('location').value)

    this.filtredOus = this.ouBackup.filter((ou: any) => ou.location?._id == this.myForm.get('location').value || !ou.location || ou.location?._id == '64647832ff8dc886e5d30cd6');
    this.filtredOus = this.ous.filter((ou: any) => ou.parent == null);
    this.selectedOus = []
    this.selectedOusIds = []
    this.selectionName = 'الجهة'
    // console.log("===> OU == get", this.filtredOus );

  }

  ouBackup: any

  async getOUs() {
    try {

      console.log("===>signup form")

      let res = await this.dataService.getData('ou');
      if (!res.error) {
        // this.ous = res.data;



        if (this.type == 'UPDATE') {
          this.ous = res.data.filter((item: any) => this.allowedTags.includes(item?.type?.tag))
        } else {
          this.ous = res.data.filter((item: any) => this.allowedTags.includes(item?.type?.tag) && item.active == true)
        }
        this.ouBackup = cloneDeep(this.ous)

        console.log("===> OU == get", this.ous);
        this.filtredOus = this.ous.filter((ou: any) => ou.parent == null);
        // let y : any = this.filtredOus.find((ou:any)=> ou._id == '643db5fc3e3890db38bb278d')
        // this.selectedOus.push(y)                                          // Get OU OF SBC
      }
    } catch (error) {
      console.log(error);
    }
  }

  filterOus(level: any) {
    return this.ous.filter((node) => node.parent === null);
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  reloadCaptcha() {
    if (window['grecaptcha']) {
      window['grecaptcha'].reset(); // Reset reCAPTCHA
    }
  }

  captchaNotLoaded = false;


  
  onPermissionChange(permission: string, checked: boolean) {
    const selected = this.myForm.get('permissionRequests')?.value || [];
    if (checked) {
      if (!selected.includes(permission)) {
        selected.push(permission);
      }
    } else {
      const index = selected.indexOf(permission);
      if (index >= 0) {
        selected.splice(index, 1);
      }
    }
    this.myForm.get('permissionRequests')?.setValue([...selected]);
  }

  initializePermissions() {
    const selectedPermissions: string[] = this.myForm.get('permissionRequests')?.value || [];
    // Reset all to false first
    Object.keys(this.permissionsForm.controls).forEach(key => {
      this.permissionsForm.get(key)?.setValue(false);
    });
  
    // Then tick only the selected ones
    selectedPermissions.forEach(permission => {
      if (this.permissionsForm.get(permission)) {
        this.permissionsForm.get(permission)?.setValue(true);
      }
    });
  }

  private applyPresetPermissions(): void {
    if (!this.myForm) {
      return;
    }
    const preset = this.presetPermissionRequests && this.presetPermissionRequests.length > 0
      ? Array.from(new Set(this.presetPermissionRequests))
      : [];
    this.myForm.get('permissionRequests')?.setValue(preset);
    if (this.permissionsForm) {
      const control = this.myForm.get('permissionRequests');
      if (control && !control.value) {
        control.setValue([]);
      }
      this.initializePermissions();
    }
  }
}
